/**
 * Direction-aware date-change cell. The new date sits on the side it moved
 * toward, with a tiny arrow marking direction:
 *   moved later:    ~~6/17~~ →6/24
 *   moved earlier:  6/10← ~~6/17~~
 */
import React from "react";
import { formatDateMonthDay } from "../../../../../utils/format";
import "./DateDelta.css";

const DateDelta: React.FC<{ oldVal: string | null; newVal: string | null }> = ({
  oldVal,
  newVal,
}) => {
  if (!oldVal && !newVal) return <span className="cwb-date-same">—</span>;
  if (!oldVal || !newVal || oldVal === newVal) {
    return <span className="cwb-date-same">{formatDateMonthDay(newVal ?? oldVal)}</span>;
  }
  const later = newVal > oldVal;
  return later ? (
    <span className="cwb-date-delta">
      <span className="cwb-date-old">{formatDateMonthDay(oldVal)}</span>
      <span className="cwb-date-new">
        <span className="cwb-date-dir">→</span>
        {formatDateMonthDay(newVal)}
      </span>
    </span>
  ) : (
    <span className="cwb-date-delta">
      <span className="cwb-date-new">
        {formatDateMonthDay(newVal)}
        <span className="cwb-date-dir">←</span>
      </span>
      <span className="cwb-date-old">{formatDateMonthDay(oldVal)}</span>
    </span>
  );
};

export default DateDelta;
